import React from 'react';
import {Modal} from 'antd';
import './index.less';

const SubscribeModal = ({visible, changeVisible, qrCodeUrl = ''}) => {

    return (
        <Modal
            className="subscribe-modal-wrapper"
            footer={false}
            centered
            width={380}
            open={visible}
            onCancel={changeVisible}
        >
            <div className="subscribe-modal">
                <h3>微信扫码关注公众号</h3>
                <img src={qrCodeUrl} alt=""/>
                <div className="footer-wrapper">
                    <p>欢迎关注“七保云服务”公众号，将为您提供最新的产品动态、业绩战报、行业资讯，快来关注体验更多服务吧~</p>
                </div>
            </div>
        </Modal>
    )
};

export default SubscribeModal;
